import { render, staticRenderFns } from "./weekBill.vue?vue&type=template&id=a401015e&scoped=true"
import script from "./weekBill.vue?vue&type=script&lang=js"
export * from "./weekBill.vue?vue&type=script&lang=js"
import style0 from "./weekBill.vue?vue&type=style&index=0&id=a401015e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a401015e",
  null
  
)

export default component.exports